import React from 'react';
import './UpdateNotification.css';
import { DSIcon } from '../design-system/primitives';

/**
 * UpdateNotification component
 * Displays a toast notification when a new PWA version is available
 * Allows users to update immediately or dismiss
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to display the notification
 * @param {Function} props.onUpdate - Callback when user clicks "Update Now"
 * @param {Function} props.onDismiss - Callback when user clicks "Later"
 */
function UpdateNotification({ show, onUpdate, onDismiss }) {
  if (!show) return null;

  return (
    <div className="update-notification-toast">
      <div className="update-notification-content">
        <span className="update-notification-icon"><DSIcon name="sparkles" /></span>
        <span className="update-notification-message">
          A new version is available!
        </span>
      </div>
      <div className="update-notification-actions">
        <button 
          className="update-notification-button update-now"
          onClick={onUpdate}
        >
          Update Now
        </button>
        <button 
          className="update-notification-button dismiss"
          onClick={onDismiss}
          aria-label="Dismiss update notification"
        >
          Later
        </button>
      </div>
    </div>
  );
}

export default UpdateNotification;
